import type { Comment, Member, Photo, Place, TripState } from '@map/shared';

/** Score net d'un lieu : somme des +1 et des -1. */
export function voteScore(state: TripState, placeId: number): number {
  let score = 0;
  for (const vote of state.votes) {
    if (vote.placeId === placeId) score += vote.value;
  }
  return score;
}

/** Vote du membre courant sur ce lieu, ou null s'il ne s'est pas prononce. */
export function myVote(state: TripState, placeId: number, memberId: number | null): -1 | 1 | null {
  if (memberId === null) return null;
  const found = state.votes.find((vote) => vote.placeId === placeId && vote.memberId === memberId);
  return found === undefined ? null : found.value;
}

export function poolPlaces(state: TripState): Place[] {
  return state.places.filter((place) => place.status === 'pool');
}

/**
 * Etapes de l'itineraire dans l'ordre. `orderIndex` est un REAL : le serveur
 * peut inserer entre deux etapes sans renumeroter, le tri se fait donc ici et
 * jamais sur l'ordre d'arrivee du tableau.
 */
export function itineraryPlaces(state: TripState): Place[] {
  return state.places
    .filter((place) => place.status === 'itinerary')
    .sort((a, b) => (a.orderIndex ?? 0) - (b.orderIndex ?? 0));
}

export function commentsOf(state: TripState, placeId: number): Comment[] {
  return state.comments
    .filter((comment) => comment.placeId === placeId)
    .sort((a, b) => a.createdAt - b.createdAt);
}

export function photosOf(state: TripState, placeId: number): Photo[] {
  return state.photos
    .filter((photo) => photo.placeId === placeId)
    .sort((a, b) => a.createdAt - b.createdAt);
}

export function memberById(state: TripState, memberId: number): Member | null {
  return state.members.find((member) => member.id === memberId) ?? null;
}
